import { AcsEventName, AcsEventNameDisplay } from "../../../enums/acsEventName";
import { EventType, ManagementEventDisplays } from "../../../enums/eventType";
import { ManagementEventName, ManagementEventNameDisplay } from "../../../enums/managementEventName";
import { RoomStatusAlarmName, RoomStatusAlarmNameDisplay } from "../../../enums/roomStatusAlarmName";
import { SiteEventNameDisplay } from "../../../enums/SiteEventName";
import { SystemErrorNameDisplay } from "../../../enums/systemErrorName";
import { EventTypeFilterFormObj } from "../../../hooks/useLogFilterRequest";

export const MANAGEMENT_EVENT_TYPE_OPTIONS = Array.from(ManagementEventDisplays);

export interface EventTypeOption {
    value: number;
    label: string;
    eventNames: Array<{ value: number; label: string }>;
}

export const EVENT_TYPE_NAME_OPTIONS: EventTypeOption[] = MANAGEMENT_EVENT_TYPE_OPTIONS.map((eventType): EventTypeOption => {
    return {
        value: eventType[0],
        label: eventType[1],
        eventNames: getEventNameOptions(eventType[0]).map((eventName) => {
            return { value: eventName[0], label: eventName[1] };
        })
    };
});

export const DEFAULT_EVENT_TYPE_NAME_VALUE: EventTypeFilterFormObj[] = [
    {
        eventType: EventType.AcsEvent,
        eventNames: Object.values(AcsEventName)
            .filter((v): v is number => typeof v === 'number' && !new Set([AcsEventName.PanelStatusChanged, AcsEventName.SensorStatusChanged]).has(v))
    },
    {
        eventType: EventType.ManagementEvent,
        eventNames: Object.values(ManagementEventName).filter((v): v is number => typeof v === 'number')
    },
    {
        eventType: EventType.RoomStatusAlarm,
        eventNames: Object.values(RoomStatusAlarmName).filter((v): v is number => typeof v === 'number')
    }
];

export function getEventNameOptions(eventType: (number | null)): [number, string][] {
    switch (eventType) {
        case EventType.AcsEvent:
            return Array.from(AcsEventNameDisplay);
        case EventType.ManagementEvent:
            return Array.from(ManagementEventNameDisplay);
        case EventType.SiteEvent:
            return Array.from(SiteEventNameDisplay);
        case EventType.SystemError:
            return Array.from(SystemErrorNameDisplay);
        case EventType.RoomStatusAlarm:
            return Array.from(RoomStatusAlarmNameDisplay);
        default:
            return [];
    }
}
